import { Injectable } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { ErrorDialogAccordion } from '../../../model/src/lib/error-dialog-accordion.model';
import { ErrorDialogMessage } from '../../../model/src/lib/error-dialog-message.model';
import { ErrorDialogAccordionComponent } from '../../shared/components/error-dialog-accordion/error-dialog-accordion.component';
import { ErrorDialogComponent } from '../../shared/components/error-dialog/error-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class SystemDialogService {
  constructor(private dialogService: DialogService) {}

  /**
   * 錯誤訊息2、錯誤訊息3可合用
   * 錯誤訊息1不可與錯誤訊息2、錯誤訊息3合用
   * @param errors 錯誤訊息(1.純文字提示: 只有給description
   * 2.欄位提示1: 左邊為欄位名稱(description), 右邊為欄位錯誤原因(errorMessage)
   * 3.欄位提示2: 左邊為資料名稱(description), 右邊為資料成功(errorMessage要給Success)或失敗原因(errorMessage))
   * @param title 顯示的 dialog 標題, 帶入空字串或 undefined 會使用預設值(System Notification)
   * @param closeCallback 關閉 dialog 後，要執行的動作
   * @param contentStyle dialog 內容樣式
   */
  showErrorDialog(
    errors: ErrorDialogMessage[],
    title = '',
    closeCallback = () => {},
    contentStyle: { [key: string]: string } = {}
  ): void {
    this.dialogService
      .open(ErrorDialogComponent, {
        showHeader: false,
        styleClass: 'p-dialog-sm',
        data: {
          title,
          errors,
        },
        contentStyle: { ...{ padding: '0' }, ...contentStyle },
      })
      .onClose.subscribe({
        next: () => {
          if (closeCallback) {
            closeCallback.call(null);
          }
        },
      });
  }

  /**
   *
   * @param errors 錯誤訊息(1. 縮放提示純文字: 縮放header給 description 內容給 errorMessage)
   * @param title 顯示的 dialog 標題, 帶入空字串或 undefined 會使用預設值(System Notification)
   * @param closeCallback 關閉 dialog 後，要執行的動作
   */
  showErrorDialogAccordion(
    errors: ErrorDialogAccordion[],
    title = '',
    closeCallback = () => {}
  ): void {
    this.dialogService
      .open(ErrorDialogAccordionComponent, {
        showHeader: false,
        styleClass: 'p-dialog-sm',
        data: {
          title,
          errors,
          onlyDescription: true,
        },
        contentStyle: { padding: '0' },
      })
      .onClose.subscribe({
        next: () => {
          if (closeCallback) {
            closeCallback.call(null);
          }
        },
      });
  }

  /**
   * 錯誤訊息1、錯誤訊息2可合用
   * @param errors 錯誤訊息(1.欄位提示1: 左邊為欄位名稱(description), 右邊為欄位錯誤原因(errorMessage)
   * 2.縮放提示欄位: 第一層 description 為縮放header, 第二層 description 為左邊欄位名稱, errorMessage 為右邊欄位錯誤原因)
   * @param title 顯示的 dialog 標題, 帶入空字串或 undefined 會使用預設值(System Notification)
   * @param closeCallback 關閉 dialog 後，要執行的動作
   */
  showErrorDialogAccordionColnum(
    errors: ErrorDialogAccordion[],
    title = '',
    closeCallback = () => {}
  ): void {
    this.dialogService
      .open(ErrorDialogAccordionComponent, {
        showHeader: false,
        styleClass: 'p-dialog-sm',
        data: {
          title,
          errors,
        },
        contentStyle: { padding: '0' },
      })
      .onClose.subscribe({
        next: () => {
          if (closeCallback) {
            closeCallback.call(null);
          }
        },
      });
  }

  /**
   *
   * @param errors 錯誤訊息(1.純問題文字提示: 只有給description)
   * @param title 顯示的 dialog 標題, 帶入空字串或 undefined 會使用預設值(System Notification)
   * @param closeCallback 可在callback fn中用this抓到回傳的字串,按ok關閉 dialog 後，回傳ok字串;按cancel關閉 dialog 後，回傳cancel字串;
   */
  showErrorDialogQuestion(
    errors: ErrorDialogMessage[],
    title = '',
    closeCallback = () => {}
  ): void {
    this.dialogService
      .open(ErrorDialogComponent, {
        showHeader: false,
        styleClass: 'p-dialog-sm',
        data: {
          title,
          errors,
          questionButton: true,
        },
        contentStyle: { padding: '0' },
      })
      .onClose.subscribe(
        (result) => {
          if (result === 'ok'){
            closeCallback();
          }
        }
      );
  }
}
